/**
 * @generated SignedSource<<2ef7cd7d9b138922fd6f1f69f24e85f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type APIKeysCreateMutation$variables = {
  name: string;
};
export type APIKeysCreateMutation$data = {
  readonly apiKeys: {
    readonly create: {
      readonly key: {
        readonly id: string;
      } | null;
      readonly token: string | null;
    } | null;
  } | null;
};
export type APIKeysCreateMutation = {
  response: APIKeysCreateMutation$data;
  variables: APIKeysCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "APIKeyMutation",
    "kind": "LinkedField",
    "name": "apiKeys",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "concreteType": "CreateAPIKeyMutation",
        "kind": "LinkedField",
        "name": "create",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "token",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "APIKey",
            "kind": "LinkedField",
            "name": "key",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "APIKeysCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "APIKeysCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f00a32c5d8c57da80bb068c1122cc822",
    "id": null,
    "metadata": {},
    "name": "APIKeysCreateMutation",
    "operationKind": "mutation",
    "text": "mutation APIKeysCreateMutation(\n  $name: String!\n) {\n  apiKeys {\n    create(name: $name) {\n      token\n      key {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8fc5515f7a51031788f5d58078bf942a";

export default node;
